import { Action } from '@ngrx/store';
import { CustomFieldInterface } from 'app/site-settings/models/custom-field.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadCustomFields implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadCustomFields;

  public readonly payload: any = undefined;
}

export class LoadCustomFieldsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadCustomFieldsCompleted;

  constructor(public readonly payload: CustomFieldInterface[]) { }
}

export class LoadCustomFieldsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadCustomFieldsFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateCustomFields implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateCustomFields;

  constructor(public readonly payload: CustomFieldInterface[]) { }
}

export class UpdateCustomFieldsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateCustomFieldsCompleted;

  constructor(public readonly payload: CustomFieldInterface[]) { }
}

export class UpdateCustomFieldsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateCustomFieldsFailed;

  constructor(public readonly payload: string) { }
}
